// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '@/services/vuestic-ui'
import store from '@/store/index'
import router from '@/router/index'
import { VuesticPlugin } from '@/services/vuestic-ui/components'
import '@/i18n/index'
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import Dayjs from 'vue-dayjs';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMask from 'v-mask'
import '@/metrics'
import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'
consoleBuildInfo()
Vue.use(VuesticPlugin)
Vue.use(VueClipboard)
Vue.use(VueAxios, axios)
Vue.use(Notifications)
Vue.use(Vuelidate)
Vue.use(Dayjs);
Vue.use(VueMask);
Vue.use(ColorThemePlugin)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
